module.exports = __webpack_public_path__ + "img/build.28957ed7.png";